export default "__VITE_ASSET__GqlWUPbo__"